/**
 * Checks if the session is valid for the given key and value.
 *
 * @param key - sessionStorage key
 * @param value - value to check against
 * @returns true if the session is valid, else false
 */
export const isSessionValid = (key: string, value: string) => {
  const item = sessionStorage.getItem(key)
  return item
    ? JSON.parse(item).value === value && JSON.parse(item).expiry > Date.now()
    : false
}

/**
 * Creates a session with the given key and value.
 *
 * @param key - sessionStorage key
 * @param value - value to store
 */
export const createSession = (key: string, value: string) => {
  sessionStorage.setItem(
    key,
    JSON.stringify({
      value: value,
      expiry: Date.now() + 3600000, // 1 hour in milliseconds
    })
  )
}
